import PdfIcon from "@assets/icons/pdf-icon.svg?react";
import PptIcon from "@assets/icons/ppt-icon.svg?react";
import XlsIcon from "@assets/icons/xls-icon.svg?react";
import DocIcon from "@assets/icons/doc-icon.svg?react";
import PlainDocIcon from "@assets/icons/plain-doc-icon.svg?react";
import FolderIcon from "@assets/icons/folder-icon.svg?react";
import * as Styled from "./styled";
import type { DownloadFile, SharepointFileType } from "@/services/api/types";
import Button from "@/components/shared-ui/Button";

type Props = {
  datoFile?: DownloadFile;
  fileLink?: { link: string; type: SharepointFileType };
  buttonLabel?: string;
  /** If this is true a before element will be added to make the clickable area include the parent (provided the parent has position: relative) */
  makeParentClickable?: boolean;
};

const FileDownloadButton = ({
  datoFile,
  fileLink,
  buttonLabel,
  makeParentClickable,
}: Props) => {
  const renderFileIcon = (fileType: string) => {
    switch (fileType) {
      case "application/pdf":
      case "pdf":
        return <PdfIcon />;
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/vnd.oasis.opendocument.text":
      case "word":
        return <DocIcon />;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.oasis.opendocument.spreadsheet":
      case "excel":
        return <XlsIcon />;
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      case "application/vnd.oasis.opendocument.presentation":
      case "powerpoint":
        return <PptIcon />;
      case "folder":
        return <FolderIcon />;
      default:
        return <PlainDocIcon />;
    }
  };

  if (buttonLabel && datoFile) {
    return (
      <Styled.FileDownloadLink
        href={datoFile.url}
        download={datoFile.filename}
        target="_blank"
        rel="noreferrer"
        makeParentClickable={makeParentClickable}
      >
        <Button variant="tertiary" label={buttonLabel} />
      </Styled.FileDownloadLink>
    );
  }
  if (buttonLabel && fileLink) {
    return (
      <Styled.FileDownloadLink
        href={fileLink.link}
        target="_blank"
        rel="noreferrer"
        makeParentClickable={makeParentClickable}
      >
        <Button variant="tertiary" label={buttonLabel} />
      </Styled.FileDownloadLink>
    );
  }

  if (fileLink) {
    return (
      <Styled.FileDownloadLink
        href={fileLink.link}
        target="_blank"
        rel="noreferrer"
        makeParentClickable={makeParentClickable}
      >
        <Styled.FileDownloadButton as="div">
          {renderFileIcon(fileLink.type)}
        </Styled.FileDownloadButton>
      </Styled.FileDownloadLink>
    );
  }
  if (datoFile) {
    return (
      <Styled.FileDownloadLink
        href={datoFile.url}
        download={datoFile.filename}
        target="_blank"
        rel="noreferrer"
        makeParentClickable={makeParentClickable}
      >
        <Styled.FileDownloadButton as="div">
          {renderFileIcon(datoFile.mimeType)}
        </Styled.FileDownloadButton>
      </Styled.FileDownloadLink>
    );
  }
  return null;
};

export default FileDownloadButton;
